<nz-result nzIcon="experiment-twotone" nzTitle="Work in progress">
  <div nz-result-extra>
    <button [routerLink]="['/']" nz-button nzType="primary">Back to Home</button>
  </div>
</nz-result>
